<template>
    <div class="sidebar" data-color="orange">
        <div class="archive-mode-select-wrapper" v-if="canShowArchiveMode">
          <div class="form-group">
            <select class="form-control" v-model="archVer" @change="onChangeArchiveModeVersion">
              <option value="" :selected="!archVer" :disabled="!archVer">{{archVer ? 'Архив режимидан чиқиш' : 'Архив режими'}}</option>
              <option value="V1">Архив 1</option>
              <option value="V2">Архив 2</option>
            </select>
          </div>
        </div>

        <div class="logo">
            <router-link tag="a" to="/" class="simple-text logo-normal">
                {{$t("main.appName")}}
            </router-link>
        </div>
        <div class="sidebar-wrapper">
            <ul class="nav">
                <SidebarMenu :data="menu.company" v-if="hasPermission(menu.company.permission)"/>
                <SidebarMenu :data="menu.client" v-if="hasPermission(menu.client.permission)" />
                <SidebarMenu :data="menu.realEstate" v-if="hasPermission(menu.realEstate.permission)"/>
                <SidebarMenu :data="menu.newRealEstate" v-if="hasPermission(menu.newRealEstate.permission)"/>
                <SidebarMenu :data="menu.asset" v-if="hasPermission(menu.asset.permission)"/>
                <SidebarMenu :data="menu.auto" v-if="hasPermission(menu.auto.permission)"/>
                <SidebarMenu :data="menu.autoLoses" v-if="hasPermission(menu.autoLoses.permission)"/>
                <SidebarMenu :data="menu.fitment" v-if="hasPermission(menu.fitment.permission)"/>
                <SidebarMenu :data="menu.evlObjectReevaluation" v-if="hasPermission(menu.evlObjectReevaluation.permission)"/>
                <!--<SidebarMenu :data="menu.business"/>-->
                <SidebarMenu :data="menu.expert2" v-if="hasPermission(menu.expert2.permission)"/>
                <template v-if="hasAnyAdminRoles()">
                    <SidebarMenu :data="menu.reports" v-if="hasPermission(menu.reports.permission)"/>
                    <SidebarMenu :data="menu.accountingAccountBook" v-if="hasPermission(menu.accountingAccountBook.permission)"/>
                    <SidebarMenu :data="menu.accountingLegalReview" v-if="hasPermission(menu.accountingLegalReview.permission)"/>
                    <SidebarMenu :data="menu.report" v-if="hasPermission(menu.report.permission)"/>
                </template>
                <SidebarMenu :data="menu.map" v-if="hasPermission(menu.map.permission)"/>
                <SidebarMenu :data="menu.eAppraisal" v-if="hasPermission(menu.eAppraisal.permission)"/>
                <SidebarMenu :data="menu.reportGeneralDirector" v-if="hasPermission(menu.reportGeneralDirector.permission)"/>
                <SidebarMenu :data="menu.finance" v-if="hasPermission(menu.finance.permission)"/>
                <SidebarMenu :data="menu.finance2" v-if="hasPermission(menu.finance.permission)"/>
                <SidebarMenu :data="menu.tender" v-if="hasPermission(menu.tender.permission)"/>
                <SidebarMenu :data="menu.companyManage" v-if="hasPermission(menu.companyManage.permission)"/>
                <SidebarMenu :data="menu.depositSalary" v-if="hasPermission(menu.depositSalary.permission)"/>
                <SidebarMenu :data="menu.paymentBalance" v-if="hasPermission(menu.paymentBalance.permission)"/>
            </ul>
        </div>
    </div>
</template>

<script>
    import SidebarMenu from "@/components/layout/SidebarMenu";
    import {mapState} from "vuex";
    import {ARCHIVE_MODE_VERSION} from "@/store";
    import Cookie from "js-cookie";
    import {getArchiveModeDetailsByVersion} from "@/shared/archive-mode-utils";
    export default {
        name: "Sidebar",
        components: {SidebarMenu},
        computed: {
          ...mapState(['archiveModeVersion', 'profile']),
          canShowArchiveMode() {
            return (process.env.VUE_APP_ARCHIVE_V1_API_URL || process.env.VUE_APP_ARCHIVE_0526_API_URL)
                    && (process.env.VUE_APP_NAME === "dev"
                    || process.env.VUE_APP_NAME === "staging"
                    || process.env.VUE_APP_NAME === "production"
                    || process.env.VUE_APP_NAME === "office") && !this.profile.forceUpdatePassword
          }
        },
        data() {
            return {
                menu: {
                    realEstate: {
                        code: 'realEstate.name',
                        icon: 'fa fa-home',
                        permission: 'REAL_ESTATE',
                        menus: [
                            {
                                shortCode: 'realEstate.category.notorious.code',
                                code: 'realEstate.category.notorious.label',
                                name: 'real-estate-list-notorious',
                                link: '/real-estate/notorious',
                                permission: 'REAL_ESTATE'
                            }, {
                                shortCode: 'realEstate.category.residential.code',
                                code: 'realEstate.category.residential.label',
                                name: 'real-estate-list-residential',
                                link: '/real-estate/residential',
                                permission: 'REAL_ESTATE'
                            }
                        ]
                    },
                    newRealEstate: {
                        code: 'newRealEstate.name',
                        icon: 'fa fa-home',
                        permission: 'NEW_REAL_ESTATE',
                        menus: [
                            {
                                shortCode: 'realEstate.category.notorious.code',
                                code: 'realEstate.category.notorious.label',
                                name: 'new-real-estate-list-notorious',
                                link: '/new-real-estate/notorious',
                                permission: 'NEW_REAL_ESTATE'
                            }, {
                                shortCode: 'realEstate.category.residential.code',
                                code: 'realEstate.category.residential.label',
                                name: 'new-real-estate-list-residential',
                                link: '/new-real-estate/residential',
                                permission: 'NEW_REAL_ESTATE'
                            },
                            {
                                shortCode: 'realEstate.plus.category.notorious.code',
                                code: 'realEstate.plus.category.notorious.label',
                                name: 'new-real-estate-plus-list-notorious',
                                link: '/new-real-estate-plus/notorious',
                                permission: 'NEW_REAL_ESTATE_PLUS'
                            },
                            {
                                shortCode: 'realEstate.plus.category.residential.code',
                                code: 'realEstate.plus.category.residential.label',
                                name: 'new-real-estate-plus-list-residential',
                                link: '/new-real-estate-plus/residential',
                                permission: 'NEW_REAL_ESTATE_PLUS'
                            },
                            {
                                shortCode: 'H',
                                code: 'newRealEstate.report',
                                name: 'new-real-estate-list-all',
                                link: '/new-real-estate/list-all',
                                permission: 'REAL_ESTATE_NEW_COMPARATIVE_ANALOGS_REPORT'
                            },
                            {
                              shortCode: 'newRealEstate.comparativeError.notorious.code',
                              code: 'newRealEstate.comparativeError.notorious.label',
                              name: 'comparative-errors-notorious-list',
                              link: '/new-real-estate/comparative-errors/notorious',
                              permission: 'REAL_ESTATE_COMPARATIVE_ERROR'
                            },
                            {
                              shortCode: 'newRealEstate.comparativeError.residential.code',
                              code: 'newRealEstate.comparativeError.residential.label',
                              name: 'comparative-errors-residential-list',
                              link: '/new-real-estate/comparative-errors/residential',
                              permission: 'REAL_ESTATE_COMPARATIVE_ERROR'
                            }
                        ]
                    },
                    asset: {
                        code: 'asset.name',
                        icon: 'fa fa-cubes',
                        permission: 'ASSET',
                        menus: [
                          {
                            shortCode: 'asset.code',
                            name: 'asset',
                            code: 'asset.name',
                            link: '/asset',
                            permission: 'ASSET'
                          },
                          {
                            shortCode: 'asset.plus.code',
                            code: 'asset.plus.label',
                            name: 'asset-plus',
                            link: '/asset-plus',
                            permission: 'ASSET_PLUS'
                          }
                        ]
                    },
                    business: {
                        code: 'business.name',
                        icon: 'fa fa-briefcase',
                        link: '/business',
                        permission: 'ASSET'
                    },
                    auto: {
                        code: 'auto.label',
                        icon: 'fa fa-car',
                        permission: 'NEW_AUTO',
                        menus: [
                            {
                                shortCode: 'A',
                                code: 'auto.label',
                                name: 'auto-evaluation',
                                link: '/auto/list',
                                permission: 'NEW_AUTO_LIST'
                            },
                            {
                                shortCode: 'K',
                                code: 'auto.comparativeLbl',
                                name: 'auto-comparative',
                                link: '/auto/comparative',
                                permission: 'NEW_AUTO_COMPARATIVE'
                            },
                            {
                                shortCode: 'P',
                                code: 'auto.plus.list',
                                name: 'auto-evaluation-plus',
                                link: '/auto/plus/list',
                                permission: 'AUTO_PLUS_LIST'
                            }
                        ]
                    },
                    autoLoses: {
                        code: 'auto.autoLoses.label',
                        icon: 'fa fa-wrench',
                        permission: 'NEW_AUTO_LOSES',
                        menus: [
                            {
                                shortCode: '',
                                code: 'auto.autoLoses.list',
                                name: 'auto-loses',
                                link: '/auto/loses-list',
                                permission: 'NEW_AUTO_LOSES_LIST'
                            },
                            {
                                shortCode: '',
                                code: 'auto.autoParts.label',
                                name: 'auto-part-list',
                                link: '/auto/part',
                                permission: 'AUTO_PART_LIST'
                            },
                            {
                                shortCode: '',
                                code: 'auto.smallAutoPart.label',
                                name: 'small-auto-part-list',
                                link: '/small/auto/part',
                                permission: 'AUTO_SMALL_PART_LIST'
                            },
                            {
                                shortCode: '',
                                code: 'auto.autoPartsNormHours.label',
                                name: 'auto-part-norm-hours-list',
                                link: '/auto/part/norm-hours',
                                permission: 'AUTO_PART_NORM_HOUR_LIST'
                            }
                        ]
                    },
                    fitment: {
                        code: 'fitment.label',
                        icon: 'fa fa-television',
                        permission: 'NEW_FITMENT',
                        menus: [
                            {
                                shortCode: '',
                                code: 'fitment.list',
                                name: 'fitment-list',
                                link: '/fitment/list',
                                permission: 'NEW_FITMENT'
                            },
                            {
                                shortCode: '',
                                code: 'fitment.plus.list',
                                name: 'fitment-plus-list',
                                link: '/fitment/plus/list',
                                permission: 'NEW_FITMENT'
                            }
                        ]
                    },
                    reports: {
                        code: 'report.title',
                        icon: 'fa fa-list-alt',
                        link: '/reports',
                        permission: 'REPORTS'
                    },
                    accountingAccountBook: {
                        code: 'accounting.title',
                        icon: 'fa fa-calculator',
                        permission: 'ACCOUNTING',
                        menus: [
                            {
                                shortCode: 'accounting.account.category.accountBook.code',
                                code: 'accounting.account.category.accountBook.label',
                                name: 'accounting-account-book',
                                link: '/accountBux',
                                permission: 'ACCOUNTING_AUTO_EQUIPMENT'
                            },
                            {
                                shortCode: 'accounting.account.category.accountBuildingBook.code',
                                code: 'accounting.account.category.accountBuildingBook.label',
                                name: 'accounting-account-building-book',
                                link: '/accountBuxBuilding',
                                permission: 'ACCOUNTING_BUILDING'
                            },
                            {
                                shortCode: 'accounting.account.category.accountAsset.code',
                                code: 'accounting.account.category.accountAsset.label',
                                name: 'accounting-asset-report',
                                link: '/accountingAssetReport',
                                permission: 'ACCOUNTING_ASSET'
                            }
                        ]
                    },
                    accountingLegalReview: {
                        code: 'accounting.titleLegalAccounting',
                        icon: 'fa fa-briefcase',
                        permission: 'LEGAL_REPORT',
                        menus: [
                            {
                                shortCode: 'report.category.legalAccounting.code',
                                code: 'report.category.legalAccounting.label',
                                name: 'legal-accounting',
                                link: '/accountLeg',
                                permission: 'LEGAL_REPORT_AUTO_EQUIPMENT'
                            },
                            {
                                shortCode: 'report.category.legalAccountingBuilding.code',
                                code: 'report.category.legalAccountingBuilding.label',
                                name: 'legal-accounting-building',
                                link: '/accountLegBuilding',
                                permission: 'LEGAL_REPORT_BUILDING'
                            },
                            {
                                shortCode: 'report.category.legalAssetReport.code',
                                code: 'report.category.legalAssetReport.label',
                                name: 'legal-asset-report',
                                link: '/legalAssetReport',
                                permission: 'LEGAL_REPORT_ASSET'
                            },
                            {
                                shortCode: 'report.category.appraisersChart.code',
                                code: 'report.category.appraisersChart.label',
                                name: 'reports-incomingChart',
                                link: '/incomingChart',
                                permission: 'REPORT_CHARTS'
                            },
                            {
                                shortCode: 'report.category.agentChart.code',
                                code: 'report.category.agentChart.label',
                                name: 'reports-agent-chart',
                                link: '/agentChart',
                                permission: 'AGENT_CHARTS'
                            }
                        ]
                    },
                    report: {
                        code: 'report.usersTitle',
                        icon: 'fa fa-calculator',
                        permission: 'REPORT_STAFF',
                        menus: [
                            {
                                shortCode: 'report.category.appraisers.code',
                                code: 'report.category.appraisers.label',
                                name: 'reports-appraisers-capacity',
                                link: '/appraisers',
                                permission: 'REPORT_STAFF_APPRAISER_AUTO'
                            },
                            {
                                shortCode: 'report.category.appraisersBuilding.code',
                                code: 'report.category.appraisersBuilding.label',
                                name: 'reports-appraisersBuilding-capacity',
                                link: '/appraisersBuilding',
                                permission: 'REPORT_STAFF_APPRAISER_REAL_ESTATE'
                            },
                            {
                                shortCode: 'report.category.agents.code',
                                code: 'report.category.agents.label',
                                name: 'reports-agents',
                                link: '/agents',
                                permission: 'REPORT_STAFF_AGENT_AUTO'
                            },
                            {
                                shortCode: 'report.category.agentsBuilding.code',
                                code: 'report.category.agentsBuilding.label',
                                name: 'reports-agents-building',
                                link: '/agentsBuilding',
                                permission: 'REPORT_STAFF_AGENT_REAL_ESTATE'
                            }
                        ]
                    },
                    map: {
                        code: 'map.title',
                        icon: 'fa fa-map',
                        permission: 'MAP',
                        menus: [
                            {
                                shortCode: 'map.category.drawPolygon.code',
                                code: 'map.category.drawPolygon.label',
                                name: 'draw-polygon',
                                link: '/config/drawPolygon',
                                permission: 'MAP_REGIONS'
                            },
                            {
                                shortCode: 'map.category.organizationMap.code',
                                code: 'map.category.organizationMap.label',
                                name: 'organization-map',
                                link: '/config/organization-map',
                                permission: 'MAP_REGIONS'
                            }
                        ]
                    },
                    eAppraisal: {
                        code: 'eAppraisal.title',
                        icon: 'fa fa-lg fa-fw fa-send',
                        permission : 'E_BAHOLASH_REAL_ESTATE',
                        menus: [
                            {
                                shortCode: 'eAppraisal.objectType.realEstate.code',
                                code: 'eAppraisal.objectType.realEstate.label',
                                name: 'real-estate-list-online-all',
                                link: '/e-appraisal/real-estate/list',
                                permission: 'E_BAHOLASH_REAL_ESTATE'
                            },
                            {
                                shortCode: 'A',
                                code: 'eAppraisal.objectType.asset.label',
                                name: 'asset-list-online-all',
                                link: '/e-appraisal/asset/list',
                                permission: 'E_BAHOLASH_ASSET'
                            },
                            {
                                shortCode: 'A',
                                code: 'eAppraisal.objectType.auto.label',
                                name: 'auto-list-online-all',
                                link: '/e-appraisal/auto/list',
                                permission: 'E_BAHOLASH_AUTOS'
                            },
                            {
                                shortCode: 'A',
                                code: 'eAppraisal.objectType.fitment.label',
                                name: 'fitment-list-online-all',
                                link: '/e-appraisal/fitment/list',
                                permission: 'E_BAHOLASH_FITMENTS'

                            },
                            {
                                shortCode: 'A',
                                code: 'eAppraisal.objectType.autonc.label',
                                name: 'autonc-list-online-all',
                                link: '/e-appraisal/autonc/list',
                                permission: 'E_BAHOLASH_AUTONC'
                            },
                            {
                                shortCode: 'A',
                                code: 'eAppraisal.objectType.order.label',
                                name: 'order-list-online-all',
                                link: '/e-appraisal/order/list',
                                permission: 'E_BAHOLASH_ORDER'
                            },
                            {
                                shortCode: 'eAppraisal.objectType.expert2.realEstate.code',
                                code: 'eAppraisal.objectType.expert2.realEstate.label',
                                name: 'expert2-list-online-all',
                                link: '/e-appraisal/expert2/real-estate/list',
                                permission: 'E_BAHOLASH_EXPERT2_REAL_ESTATE'
                            },
                            {
                                shortCode: 'eAppraisal.objectType.expert2.auto.code',
                                code: 'eAppraisal.objectType.expert2.auto.label',
                                name: 'expert2-auto-list-online',
                                link: '/e-appraisal/expert2/auto/list',
                                permission: 'E_BAHOLASH_EXPERT2_AUTO'
                            },
                            {
                                shortCode: 'eAppraisal.objectType.expert2.auto.code',
                                code: 'eAppraisal.objectType.expert2.losses.label',
                                name: 'expert2-losses-list-online',
                                link: '/e-appraisal/expert2/losses/list',
                                permission: 'E_BAHOLASH_EXPERT2_AUTO'
                            },
                            {
                                shortCode: 'eAppraisal.objectType.expert2.fitment.code',
                                code: 'eAppraisal.objectType.expert2.fitment.label',
                                name: 'expert2-fitment-list-online',
                                link: '/e-appraisal/expert2/fitment/list',
                                permission: 'E_BAHOLASH_EXPERT2_FITMENT'
                            },
                            {
                                shortCode: 'eAppraisal.objectType.expert2.asset.code',
                                code: 'eAppraisal.objectType.expert2.asset.label',
                                name: 'expert2-asset-list-online-all',
                                link: '/e-appraisal/expert2/asset/list',
                                permission: 'E_BAHOLASH_EXPERT2_ASSET'
                            }
                        ]
                    },
                    reportGeneralDirector: {
                        code: 'reportGeneralDirector.title',
                        icon: 'fa fa-keyboard-o',
                        permission : 'REPORT_GENERAL_DIRECTOR',
                        menus: [
                            {
                                shortCode: 'reportGeneralDirector.category.reportOfWorkDone.code',
                                code: 'reportGeneralDirector.category.reportOfWorkDone.label',
                                name: 'report-of-work-done-list',
                                link: '/report-general-director/report-of-work-done/list',
                                permission: 'REPORT_OF_WORK_DONE'
                            },
                            {
                                shortCode: 'reportGeneralDirector.category.expenses.code',
                                code: 'reportGeneralDirector.category.expenses.label',
                                name: 'company-expenses',
                                link: '/report-general-director/company-expenses',
                                permission: 'REPORT_GENERAL_DIRECTOR_COMPANY_EXPENSE'
                            },
                            {
                                shortCode: 'reportGeneralDirector.category.realTimeWorkDone.code',
                                code: 'reportGeneralDirector.category.realTimeWorkDone.label',
                                name: 'real-time-work-done',
                                link: '/report/general-director/real-time-report',
                                permission: 'REPORT_GENERAL_DIRECTOR_TIME_WORK_DONE'
                            },
                            {
                                shortCode: 'reportGeneralDirector.category.income.code',
                                code: 'reportGeneralDirector.category.income.label',
                                name: 'companyincome',
                                link: '/report-general-director/companyincome',
                                permission: 'REPORT_GENERAL_DIRECTOR_COMPANY_INCOME'
                            },
                            {
                                shortCode: 'regionalLeader.code',
                                code: 'regionalLeader.titleList',
                                name: 'regional-leader-list',
                                link: '/regional-leader/list',
                                permission: 'REGIONAL_LEADER_LIST'
                            },
                        ]
                    },
                    evlObjectReevaluation: {
                        code: 'reEvaluation.name',
                        icon: 'fa fa-building-o',
                        link: '/re-evaluation',
                        permission: 'RE_EVALUATE'
                    },
                    finance: {
                        code: 'finance.name',
                        icon: 'fa fa-credit-card',
                        permission: 'FINANCE',
                        menus: [
                            {
                                shortCode: 'finance.uzCard.transaction.code',
                                code: 'finance.uzCard.transaction.label',
                                name: 'uzcard-transactions',
                                link: '/uzcard/transactions',
                                permission: 'UZ_CARD_TRANSACTIONS_LIST'
                            },
                            {
                                shortCode: 'finance.userBalance.code',
                                code: 'finance.userBalance.label',
                                name: 'user-balance',
                                link: '/finance/user-balance',
                                permission:  'USER_BALANCE'
                            },
                            {
                                shortCode: 'finance.ipoteka.transaction.code',
                                code: 'finance.ipoteka.transaction.creditLabel',
                                name: 'ipoteka-credit-transactions',
                                link: '/finance/ipoteka/credit-transactions',
                                permission: 'IPOTEKA_BANK_CREDIT_TRANSACTIONS_LIST'
                            },
                            {
                                shortCode: 'finance.ipoteka.transaction.code',
                                code: 'finance.ipoteka.transaction.debitLabel',
                                name: 'ipoteka-debit-transactions',
                                link: '/finance/ipoteka/debit-transactions',
                                permission: 'IPOTEKA_BANK_DEBIT_TRANSACTIONS_LIST'
                            },
                            {
                                shortCode: 'finance.ipoteka.transaction.code',
                                code: 'finance.ipoteka.titleListFixedExpenses',
                                name: 'ipoteka-fixed-expenses-list',
                                link: '/finance/ipoteka/fixed-expenses-list',
                                permission: 'IPOTEKA_BANK_FIXED_EXPENSES_LIST'
                            },
                            {
                                shortCode: 'finance.ipoteka.transaction.code',
                                code: 'finance.ipoteka.titleListFixedReadyTransferExpenses',
                                name: 'fixed-expenses-ready-transfer-list',
                                link: '/finance/ipoteka/fixed-expenses-ready-transfer-list',
                                permission: 'IPOTEKA_BANK_FIXED_EXPENSES_READY_TRANSFER_LIST'
                            },
                            {
                                shortCode: 'finance.ipoteka.transaction.code',
                                code: 'finance.ipoteka.titleIpotekaPaymentList',
                                name: 'ipoteka-payment-list',
                                link: '/finance/ipoteka/payment-list',
                                permission: 'IPOTEKA_BANK_PAYMENT_TRANSACTIONS_LIST'
                            },
                            {
                                shortCode: 'finance.deposit.code',
                                code: 'finance.deposit.titleList',
                                name: 'deposit-list',
                                link: '/finance/deposit/deposit-list',
                                permission: 'FINANCE_DEPOSIT_LIST'
                            },
                            {
                                shortCode: 'finance.deposit.appraiser.code',
                                code: 'finance.deposit.appraiser.title',
                                name: 'deposit-list-appraiser',
                                link: '/finance/deposit/deposit-list-appraiser',
                                permission: 'FINANCE_DEPOSIT_LIST_APPRAISER'
                            },
                            {
                                shortCode: 'finance.deposit.regionalLeader.code',
                                code: 'finance.deposit.regionalLeader.title',
                                name: 'deposit-regional-leader-list',
                                link: '/finance/deposit/deposit-regional-leader-list',
                                permission: 'FINANCE_DEPOSIT_LIST_REGIONAL_LEADER'
                            },
                            {
                                shortCode: 'finance.balance.code',
                                code: 'finance.balance.titleList',
                                name: 'users-balance-list',
                                link: '/finance/balance/users-balance-list',
                                permission: 'FINANCE_USER_BALANCE_LIST'
                            },
                            {
                                shortCode: 'finance.salary.code',
                                code: 'finance.salary.titleList',
                                name: 'user-salary-list',
                                link: '/finance/user-salary-list',
                                permission: 'FINANCE_USER_SALARY_LIST'
                            },

                        ]
                    },
                    finance2: {
                        code: 'finance2.name',
                        icon: 'fa fa-money',
                        permission: 'FINANCE',
                        menus: [
                            {
                                shortCode: 'finance2.universalBank.transaction.credit.code',
                                code: 'finance2.universalBank.transaction.credit.label',
                                name: 'universal-bank-credit-transactions',
                                link: '/finance/universal-bank/credit',
                                permission: 'UNIVERSAL_BANK_CREDIT_TRANSACTIONS_LIST'
                            },
                            {
                                shortCode: 'finance2.universalBank.transaction.debit.code',
                                code: 'finance2.universalBank.transaction.debit.label',
                                name: 'universal-bank-debit-transactions',
                                link: '/finance/universal-bank/debit',
                                permission: 'UNIVERSAL_BANK_DEBIT_TRANSACTIONS_LIST'
                            },
                            {
                                shortCode: 'finance2.universalBank.transaction.payment.code',
                                code: 'finance2.universalBank.transaction.payment.label',
                                name: 'universal-bank-payment-transactions',
                                link: '/finance/universal-bank/transaction/payment',
                                permission: 'UNIVERSAL_BANK_PAYMENT_TRANSACTIONS_LIST'
                            },
                            {
                                shortCode: 'finance2.paymentCode.code',
                                code: 'finance2.paymentCode.label',
                                name: 'payment-code',
                                link: '/finance/payment-code',
                                permission: 'UNIVERSAL_BANK_PAYMENT_CODE_LIST'
                            },
                            {
                                shortCode: 'finance2.universalBank.transaction.fixedExpenseReadyTransfer.code',
                                code: 'finance2.universalBank.transaction.fixedExpenseReadyTransfer.label',
                                name: 'universal-bank-fixed-expenses-ready-transfer-list',
                                link: '/finance/universal-bank/transaction/fixed-expenses-ready-transfer-list',
                                permission: 'UNIVERSAL_BANK_FIXED_EXPENSES_READY_TRANSFER_LIST'
                            }
                        ]
                    },
                    tender: {
                        code: 'tender.name',
                        icon: 'fa fa-building-o',
                        link: '/tender',
                        permission: 'TENDER'
                    },
                    companyManage: {
                        code: 'companyManage.title',
                        icon: 'fa fa-cc',
                        permission: 'COMPANY_MANAGE',
                        menus: [
                            {
                                shortCode: 'companyManage.companyPersonalCabinet.code',
                                code: 'companyManage.companyPersonalCabinet.label',
                                name: 'company-personal-cabinet',
                                link: '/company-manage/company-personal-cabinet',
                                permission: 'COMPANY_PERSONAL_CABINET'
                            },
                        ]
                    },
                    depositSalary: {
                        code: 'depositSalary.title',
                        icon: 'fa fa-ticket',
                        permission: 'DEPOSIT_SALARY',
                        menus: [
                            {
                                shortCode: 'depositSalary.usersSalary.code',
                                code: 'depositSalary.usersSalary.label',
                                name: 'users-salary',
                                link: '/appraiser/salary',
                                permission: 'DEPOSIT_APPRAISER_SALARY'
                            },
                        ]
                    },
                    paymentBalance: {
                        code: 'paymentBalance.title',
                        icon: 'fa fa-building',
                        link: '/payment-balance',
                        permission: 'PAYMENT_BALANCE'
                    },
                    expert2: {
                        code: 'expert2.name',
                        icon: 'fa fa-list-ol',
                        permission: 'EXPERT2',
                        menus: [
                            {
                                shortCode: 'expert2.list.code',
                                code: 'expert2.list.label',
                                name: 'expert2-list',
                                link: '/expert2/list',
                                permission: 'EXPERT2'
                            }
                        ]
                    },
                    company: {
                        code: 'company.name',
                        icon: 'fa fa-users',
                        permission: 'V2_COMPANY',
                        menus: [
                            {
                                shortCode: 'company.profile.code',
                                code: 'company.profile.label',
                                name: 'company-profile',
                                link: '/company/profile',
                                permission: 'V2_COMPANY_PROFILE'
                            },
                            {
                              shortCode: 'director.list.code',
                              code: 'director.list.label',
                              name: 'director-list',
                              link: '/company/director',
                              permission: 'DIRECTOR'
                            },
                            // {
                            //     shortCode: 'employees.list.code',
                            //     code: 'employees.list.label',
                            //     name: 'employees-list',
                            //     link: '/company/employees/list',
                            //     permission: 'DIRECTOR'
                            // },
                            {
                                shortCode: 'appraiserHelpers.list.code',
                                code: 'appraiserHelpers.list.label',
                                name: 'appraiser-helper-list',
                                link: '/company/appraiser-helper/list',
                                permission: 'V2_APPRAISER_HELPER'
                            },
                            {
                              shortCode: 'user.list.code',
                              code: 'user.list.label',
                              name: 'user-list',
                              link: '/user/list',
                              permission: 'V2_USERS'
                            }
                        ]
                    },
                    client: {
                        code: 'client.name',
                        icon: 'fa fa-lg fa-fw fa-puzzle-piece',
                        permission: 'CLIENT',
                        menus: [
                            {
                                shortCode: 'client.physical.code',
                                code: 'client.physical.label',
                                name: 'client-physical-list',
                                link: '/client/physical/list',
                                permission: 'PHYSICAL_ENTITY'
                            },
                            {
                                shortCode: 'client.legal.code',
                                code: 'client.legal.label',
                                name: 'client-legal-list',
                                link: '/client/legal/list',
                                permission: 'LEGAL_ENTITY'
                            }
                        ]
                    }
                },
                archVer: ''
            }
        },
        methods: {
            onChangeArchiveModeVersion() {
              this.$store.dispatch('toggleArchiveMode', this.archVer);
            }
        },
        mounted() {
          if(this.canShowArchiveMode) {
            this.archVer = Cookie.get('archive_version') || ''
            this.$store.commit(ARCHIVE_MODE_VERSION, this.archVer || '');
          }
          else {
            this.$store.commit(ARCHIVE_MODE_VERSION, '');
          }
        },
        watch: {
          archiveModeVersion: {
            handler: function(val) {
              this.$http.defaults.baseURL = getArchiveModeDetailsByVersion(val).url;
            },
            deep: true
          }
        }
    }
</script>
